import React, { FC, ReactNode, ButtonHTMLAttributes, AnchorHTMLAttributes } from 'react'
import { StyledButton } from './Label.style'
import styled from 'styled-components'

import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

const LabelToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow placement={'top'} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: `${theme.colors.black}`,
    opacity: 0.95,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgba(24, 15, 20, 0.95)',
    color: `${theme.colors.white}`,
    width: 201,
    height: 68,
    borderRadius: 15,
    fontFamily: `${theme.fonts.inter}`,
    fontSize: '12px',
    padding: 16,
    arrow: 'true',
    position: 'relative',
    left: -30,
    top: 7,
  },
}))

export type themeType = {
  black: string
  blackFull: string
}

export type ButtonSizeType = 'sm' | number

export interface ButtonType {
  children?: ReactNode
  href?: string
  size?: ButtonSizeType
  disabled?: boolean
  themetype?: keyof themeType
}

const Label: FC<ButtonType & ButtonHTMLAttributes<HTMLButtonElement> & AnchorHTMLAttributes<HTMLAllCollection>> = (
  props: ButtonType
) => {
  const { children, ...rest } = props
  const toolTipText = 'Этот продукт разработан и обслуживается в России'

  return (
    <LabelToolTip title={toolTipText}>
      <StyledButton type={'button'} {...rest}>
        {children}
      </StyledButton>
    </LabelToolTip>
  )
}

export default Label
